import { IStatePerson } from "@/apps/merchant3/models/IStatePerson";

/**
 * MUTATIONS
 */
const mutations = {
  SET_USER_LOCATION: (state: IStatePerson, payload: string | null): void => {
    state.location = payload;
  },

  SET_USER_TYPE: (state: IStatePerson, payload: string | null): void => {
    state.userType = payload;
  },

  SET_USER_TAG: (state: IStatePerson, payload: string | null): void => {
    state.userTag = payload;
  },

  SET_TERMS_AND_CONDITIONS_ACCEPT: (
    state: IStatePerson,
    payload: boolean | null
  ): void => {
    state.userData.termsAndConditionsAccept = payload;
  },

  SET_VERSION_HASH: (state: IStatePerson, payload: number | null): void => {
    state.versionHash = payload;
  },

  SET_PRIVACY_POLICY_ACCEPT: (
    state: IStatePerson,
    payload: boolean | null
  ): void => {
    state.userData.privacyPolicyAccept = payload;
  },

  SET_FRONT_IMAGE_URL: (state: IStatePerson, payload: string | null): void => {
    state.userData.frontImageURL = payload;
  },

  SET_BACK_IMAGE_URL: (state: IStatePerson, payload: string | null): void => {
    state.userData.backImageURL = payload;
  },

  SET_SELFIE_IMAGE_URL: (state: IStatePerson, payload: string | null): void => {
    state.userData.selfieImageURL = payload;
  },

  SET_PROOF_OF_ADDRESS_IMAGE_URL: (
    state: IStatePerson,
    payload: string | null
  ): void => {
    state.userData.proofOfAddressImageURL = payload;
  },

  SET_PHONE_NUMBER: (state: IStatePerson, payload: string | null): void => {
    state.userData.phoneNumber = payload;
  },

  SET_EMAIL: (state: IStatePerson, payload: string | null): void => {
    state.userData.email = payload;
  },

  SET_PHONE_VERIFY: (state: IStatePerson, payload: boolean | null): void => {
    state.userData.phoneVerify = payload;
  },

  SET_TRANSCRIPTION: (
    state: IStatePerson,
    payload: {
      cxManualTranscriptionRecorded: boolean;
      nationalIdentificationRecorded: boolean;
    }
  ): void => {
    state.cxTranscriptions = payload;
  },
};

export default mutations;
